import {UmpireClub} from '../umpire-club';
import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireImage} from '../umpire-image';

export interface UmpireComponentClub
  extends UmpireComponent<UmpireComponentTypeEnum.CLUB> {
  club: UmpireClub;
  external_url: string;
  image: UmpireImage | null;
  background_photo: UmpireImage | null;
  additional_asset: UmpireImage | null;
}
